import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const AsendiaCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  password: input<string>({ validator: nonEmptyValidator }),
  username: input<string>({ validator: nonEmptyValidator }),
  apiKey: input<string>({ validator: nonEmptyValidator }),
  carrierFacility: input<string>(),
  subAccountNumber: input<string>(),
});

export type AsendiaCarrierValue = InputSchema.Value<typeof AsendiaCarrierInput>;

export type AsendiaCarrierForm = InputSchema.Input<typeof AsendiaCarrierInput>;

export const asendiaCarrierDefault = (): AsendiaCarrierValue => ({
  accountNumber: "",
  password: "",
  username: "",
  apiKey: "",
  carrierFacility: "",
  subAccountNumber: "",
});

export const CreateAsendiaCarrierForm = memo(function CreateAsendiaCarrierForm({
  carrierInput,
}: {
  carrierInput: AsendiaCarrierForm;
}) {
  return (
    <>
      <RedoTextInput
        label="Account number"
        placeholder=""
        setValue={carrierInput.inputs.accountNumber.setValue}
        value={carrierInput.inputs.accountNumber.value}
      />
      <RedoTextInput
        inputTypeHint="password"
        label="Password"
        placeholder=""
        setValue={carrierInput.inputs.password.setValue}
        value={carrierInput.inputs.password.value}
      />
      <RedoTextInput
        label="Username"
        placeholder=""
        setValue={carrierInput.inputs.username.setValue}
        value={carrierInput.inputs.username.value}
      />
      <RedoTextInput
        label="API key"
        placeholder=""
        setValue={carrierInput.inputs.apiKey.setValue}
        value={carrierInput.inputs.apiKey.value}
      />
      <RedoTextInput
        label="Carrier facility (optional)"
        placeholder=""
        setValue={carrierInput.inputs.carrierFacility.setValue}
        value={carrierInput.inputs.carrierFacility.value}
      />
      <RedoTextInput
        label="Sub account number (optional)"
        placeholder=""
        setValue={carrierInput.inputs.subAccountNumber.setValue}
        value={carrierInput.inputs.subAccountNumber.value}
      />
    </>
  );
});
